import styled from "styled-components";
import { TableCell } from "./table-cell/table-cell";

export const StyledTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: calc(1.8125rem / 6);
`;
